import AdvancedBanner from './advanced-banner/advanced-banner.vue'
import AdvancedCarousel from './advanced-carousel/advanced-carousel.vue'
import AdvancedSearch from './advanced-search'
import Banner from './banner/banner.vue'
import BannerDam from './banner-dam/banner-dam.vue'
import BannerPlaceholder from './banner-placeholder/banner-placeholder.vue'
import CardsWrapper from './cards-wrapper/cards-wrapper.vue'
import Carousel from './carousel/carousel.vue'
import CookieBanner from './cookie-banner/cookie-banner.vue'
import DynamicTable from './dynamic-table/dynamic-table.vue'
import Gallery from './gallery/gallery.vue'
import GalleryMedia from './gallery/gallery-media.vue'
import Headquarters from './headquarters/headquarters.vue'
import Hero from './hero/hero.vue'
import MapV2 from './map-v2'
import MediaLibrary from './media-library/media-library.vue'
import MultiTabs from './multi-tabs/multi-tabs.vue'
import NtForm from './nt-form/nt-form.vue'
import NtTemplateItem from './nt-template-item/nt-template-item.vue'
import PdfPreview from './pdf-preview/pdf-preview.vue'
import PdfPreviewShare from './pdf-preview/pdf-preview-share.vue'
import PdfPreviewTrigger from './pdf-preview/pdf-preview-trigger.vue'
import PreviewModal from './preview-modal/preview-modal.vue'
import ModalConfig from './preview-modal/modal-config.vue'
import MenuAccessibility from './menu-accessibility/menu-accessibility.vue'
import RecentNewsWrapper from './recent-news-wrapper'
import DynamicScript from './script/script.vue'
import SmartBanner from './smart-banner/smart-banner.vue'
import SmartBannerPrimary from './smart-banner/smart-banner--primary.vue'
import SmartBannerSecondary from './smart-banner/smart-banner--secondary.vue'
import SmartBannerTertiary from './smart-banner/smart-banner--tertiary.vue'
import SmartBannerQuaternary from './smart-banner/smart-banner--quaternary.vue'
import SmartBannerQuinary from './smart-banner/smart-banner--quinary.vue'
import SmartBannerSenary from './smart-banner/smart-banner--senary.vue'
import SmartBannerSeptenary from './smart-banner/smart-banner--septenary.vue'
import SmartBannerOctonary from './smart-banner/smart-banner--octonary.vue'
import SocialPostsCarousel from './social-posts-carousel/social-posts-carousel.vue'
import SocialFeedWrapper from './social-feed-wrapper/social-feed-wrapper.vue'
import Tabs from './tabs/tabs.vue'
import TabsContent from './tabs/tabs-content.vue'
import TabsNav from './tabs/tabs-nav.vue'
import TopicsWrapper from './topics-wrapper/topics-wrapper.vue'
import VideosCarousel from './videos-carousel/videos-carousel.vue'
import VtTimeline from './vt-timeline/vt-timeline.vue'
import VtVideo from './vt-video/vt-video.vue'
import VtVideoBackground from './vt-video-background/vt-video-background.vue'

export default [
  AdvancedBanner,
  AdvancedCarousel,
  AdvancedSearch,
  Banner,
  BannerDam,
  BannerPlaceholder,
  CardsWrapper,
  Carousel,
  CookieBanner,
  DynamicTable,
  Gallery,
  GalleryMedia,
  Headquarters,
  Hero,
  MapV2,
  MediaLibrary,
  MultiTabs,
  NtForm,
  NtTemplateItem,
  PdfPreview,
  PdfPreviewShare,
  PdfPreviewTrigger,
  PreviewModal,
  ModalConfig,
  RecentNewsWrapper,
  DynamicScript,
  SmartBanner,
  SmartBannerPrimary,
  SmartBannerSecondary,
  SmartBannerTertiary,
  SmartBannerQuaternary,
  SmartBannerQuinary,
  SmartBannerSenary,
  SmartBannerSeptenary,
  SmartBannerOctonary,
  SocialPostsCarousel,
  SocialFeedWrapper,
  MenuAccessibility,
  Tabs,
  TabsContent,
  TabsNav,
  TopicsWrapper,
  VideosCarousel,
  VtTimeline,
  VtVideo,
  VtVideoBackground
]
